<template>
  <div class="row myrow content-mb-42" v-if="$parent.$parent.rerender">
    <div
      class="col-xs-12 mycol"
      v-bind:class="{
        'has-error': $parent.$parent.checkErrorField(
          'PROJECTS',
          'LOGIC',
          'UF_MONTH_RETURN'
        )
      }"
    >
      <input
        v-on:keyup="
          $parent.$parent.removeError('PROJECTS', 'LOGIC', 'UF_MONTH_RETURN')
        "
        v-on:keypress="isNumber($event)"
        :disabled="$parent.$parent.projectDisabled"
        type="text"
        class="i-main-style i-wid-13"
        v-model="$parent.project.UF_MONTH_RETURN"
        v-on:change="$parent.$parent.updateAllSumPercent()"
      />
      <div class="error-text">
        {{
          $parent.$parent.checkErrorText("PROJECTS", "LOGIC", "UF_MONTH_RETURN")
        }}
      </div>
    </div>
    <div v-show="$parent.$parent.getProgramCode() === 'lekarstva_'">
      <p>&nbsp;</p>
      <p>
        Срок возврата займа может ограничиваться 5 годами если удовлетворены
        следующие условия:
      </p>
      <p>
        *Производство жизненно необходимых и важнейших лекарственных препаратов
        для медицинского применения
      </p>
      <p>
        **сумма запрошенного займа превышает 20% среднегодовой выручки от
        реализации лекарственных препаратов для медицинского применения
        Заявителя за последние три года
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: "uf_month_return",
  methods: {
    isNumber: function(evt) {
      evt = evt ? evt : window.event;
      let charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    }
  }
};
</script>

<style scoped></style>
